"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _uuid = require("uuid");
var R = _interopRequireWildcard(require("ramda"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactSelect = _interopRequireDefault(require("react-select"));
var _MultiInput = _interopRequireDefault(require("./MultiInput"));
var _Select = _interopRequireDefault(require("./Select.style"));
var _InputError = _interopRequireDefault(require("../errors/InputError"));
var _SelectedItem = _interopRequireDefault(require("./SelectedItem"));
var _tooltip = require("../tooltip");
var _excluded = ["ariaLabel", "errors", "disableUnderline", "value", "onChange", "id", "optionClassName", "multi", "createable", "labelKey", "placeholder"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Select = function Select(_ref) {
  var ariaLabel = _ref.ariaLabel,
    errors = _ref.errors,
    disableUnderline = _ref.disableUnderline,
    value = _ref.value,
    onChange = _ref.onChange,
    id = _ref.id,
    optionClassName = _ref.optionClassName,
    multi = _ref.multi,
    createable = _ref.createable,
    labelKey = _ref.labelKey,
    placeholder = _ref.placeholder,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var multiProps = null;
  var newId = R.isEmpty(id) ? (0, _uuid.v4)() : id;
  if (multi) {
    multiProps = {
      multi: multi,
      closeOnSelect: false,
      searchable: true,
      valueComponent: _SelectedItem["default"],
      backspaceRemoves: true,
      deleteRemoves: true
    };
  }
  var renderIcon = function renderIcon() {
    return /*#__PURE__*/_react["default"].createElement("i", {
      className: "icon icon-ion-chevron-down"
    });
  };
  var renderValue = function renderValue(_ref2) {
    var vl = _ref2.vl;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_tooltip.Tooltip, {
      id: "tip-".concat(newId)
    }), /*#__PURE__*/_react["default"].createElement("span", {
      "data-tip": R.prop(labelKey, vl),
      "data-for": "tip-".concat(newId),
      "data-place": "top"
    }, R.prop(labelKey, vl)));
  };
  return /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    className: "select-wrapper",
    "data-testid": "select-wrapper"
  }, createable ? /*#__PURE__*/_react["default"].createElement(_MultiInput["default"], _extends({
    value: value,
    onChange: onChange,
    placeholder: placeholder
  }, otherProps, multiProps)) : /*#__PURE__*/_react["default"].createElement(_reactSelect["default"], _extends({
    autoComplete: "off",
    optionClassName: optionClassName,
    disableUnderline: disableUnderline,
    arrowRenderer: renderIcon,
    value: value,
    onChange: onChange,
    backspaceRemoves: false,
    deleteRemoves: false,
    "aria-label": ariaLabel || placeholder,
    placeholder: placeholder,
    clearable: false,
    instanceId: newId,
    errors: errors,
    matchProp: "label",
    inputProps: {
      autoComplete: 'off'
    },
    labelKey: labelKey,
    valueRenderer: function valueRenderer(vl) {
      return renderValue({
        vl: vl
      });
    },
    id: newId,
    className: newId
  }, multiProps, otherProps)), errors && (Array.isArray(errors) ? errors.map(function (error) {
    return /*#__PURE__*/_react["default"].createElement(_InputError["default"], {
      key: "".concat(error),
      message: error
    });
  }) : /*#__PURE__*/_react["default"].createElement(_InputError["default"], {
    message: errors,
    id: "".concat(id, "Error")
  })));
};
Select.defaultProps = {
  createable: false,
  errors: null,
  disableUnderline: false,
  optionClassName: '',
  value: null,
  ariaLabel: null,
  multi: false,
  id: '',
  labelKey: 'label',
  placeholder: ''
};
Select.propTypes = {
  labelKey: _propTypes["default"].string,
  createable: _propTypes["default"].bool,
  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  errors: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),
  /**
   * If `true` hides the bottom border of the input/
   */
  disableUnderline: _propTypes["default"].bool,
  // eslint-disable-next-line react/forbid-prop-types
  value: _propTypes["default"].any,
  ariaLabel: _propTypes["default"].string,
  onChange: _propTypes["default"].func.isRequired,
  id: _propTypes["default"].string,
  optionClassName: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  multi: _propTypes["default"].bool
};
Select.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Select",
  "props": {
    "createable": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "errors": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "If `true`, the input will indicate an error. This is normally obtained via context from\r\nFormControl.",
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "arrayOf",
          "value": {
            "name": "string"
          }
        }]
      },
      "required": false
    },
    "disableUnderline": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "If `true` hides the bottom border of the input/",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "optionClassName": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "value": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "any"
      },
      "required": false
    },
    "ariaLabel": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "multi": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "id": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "labelKey": {
      "defaultValue": {
        "value": "'label'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "placeholder": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "onChange": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    }
  }
};
var _default = /*#__PURE__*/(0, _react.memo)(Select);
exports["default"] = _default;